import { Locale } from './locale';
import { Localized, Region } from './localization';

export class LocaleSettings implements Localized {
  static readonly DEFAULT = new LocaleSettings('en-US', Region.US, 'USD');

  private locale: Locale;
  private region: Region;
  private country: string;

  constructor(localeId: Locale | string, regionId: Region | number, private currency: string, country?: string) {
    this.region = typeof regionId === 'number' ? (regionId as Region) : regionId;
    this.locale = typeof localeId === 'string' ? Locale.parse(localeId) : localeId;
    this.country = country === undefined ? this.locale.getRegion() : country;
  }

  /**
   * @inheritDoc
   */
  getLocale(): Locale {
    return this.locale;
  }

  /**
   * @inheritDoc
   */
  getRegion(): Region {
    return this.region;
  }

  /**
   * @inheritDoc
   */
  getRegionCode(): string {
    return Region[this.region];
  }

  /**
   * @inheritDoc
   */
  getCurrency(): string {
    return this.currency;
  }

  /**
   * @inheritDoc
   */
  getCountry(): string {
    return this.country;
  }

  /**
   * @inheritDoc
   */
  getLanguage(): string {
    return this.locale.getLanguage();
  }

  /**
   * @inheritDoc
   */
  getLocaleRegion(): string {
    return this.locale.getRegion();
  }
}
